import api from './api';

export interface Uom {
  id: number;
  code: string;
  description: string | null;
  createdBy: number | null;
  updatedBy: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface UomListResult {
  items: Uom[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface ImportResult {
  totalRows: number;
  succeeded: number;
  failed: number;
  results: { row: number; status: string; reason?: string }[];
}

export const uomService = {
  list: async (params?: { page?: number; limit?: number; search?: string }): Promise<UomListResult> => {
    const query = new URLSearchParams();
    if (params?.page) query.append('page', String(params.page));
    if (params?.limit) query.append('limit', String(params.limit));
    if (params?.search) query.append('search', params.search);
    const response = await api.get(`/master-data/uoms?${query}`);
    return (response as any).data;
  },

  create: async (payload: { code: string; description?: string | null }): Promise<Uom> => {
    const response = await api.post('/master-data/uoms', payload);
    return (response as any).data;
  },

  update: async (id: number, payload: { code?: string; description?: string | null }): Promise<Uom> => {
    const response = await api.put(`/master-data/uoms/${id}`, payload);
    return (response as any).data;
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(`/master-data/uoms/${id}`);
  },

  export: async (): Promise<Uom[]> => {
    const response = await api.get('/master-data/uoms/export');
    return (response as any).data;
  },

  import: async (file: File): Promise<ImportResult> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/master-data/uoms/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return (response as any).data;
  },
};
